export const goBack = (history, baseUrl, storageKey) => {
  const prevParams = storageKey ? sessionStorage.getItem(storageKey) : null;
  let url = baseUrl;
  if (prevParams && storageKey) {
    url = `${baseUrl}${prevParams}`;
    sessionStorage.removeItem(storageKey);
  }
  history.push(url);
};
